import React from "reactn"
import { graphql } from "gatsby"
import {
  VStack,
  Center,
} from '@chakra-ui/react';
import { BlockListing } from "./blocks-listing";

export function SectionCard({ seo, sectionCard, isStory, eager, location }) {
  const {
    title,
    bgcolor,
    isfullwidth,
  } = sectionCard  
  return (
    <Center>
      <VStack id="SectionCard"
        w={isfullwidth ? 'full' : ['90%','90%','90%','80%']}
        bgColor={bgcolor ? bgcolor.hex : 'white'}        
        paddingBottom={5}
        paddingTop={5}
        marginTop={0}
        marginBottom={0}
        >         
        <BlockListing isStory={isStory} eager={eager} key={title} blocks={sectionCard.rows}  seo={seo} location={location}/>        
      </VStack>
      </Center>
  );
}

export const storyQuery = graphql`
  fragment StorySectionCard on DatoCmsSection {
    model { apiKey }
    id
    name
    isfullwidth
    bgcolor {
      hex
    }
    titlecolor {
      hex
    }
    textcolor {
      hex
    }
    rows {
      ... on DatoCmsBlock {
        ...StoryBlockCard
      }
    }
  }
`

export const query = graphql`
  fragment SectionCard on DatoCmsSection {
    model { apiKey }
    id
    name
    isfullwidth
    bgcolor {
      hex
    }
    titlecolor {
      hex
    }
    textcolor {
      hex
    }
    rows {
      ... on DatoCmsBlock {
        ...BlockCard
      }
    }
  }
`
